module.exports = __webpack_public_path__ + "static/img/btn.9ea22793.png";